import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import VoucherCard from './club/VoucherCard';
import MovementRow from './club/MovementRow';
import { getVoucherStatus, withRunningBalance } from '../utils/loyalty';

const ClubHistory = ({ userId, setCurrentView, userPoints = 0, userProfile }) => {
  const [movimientos, setMovimientos] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('vouchers');

  useEffect(() => {
    const load = async () => {
      if (!userId) return;
      setLoading(true);
      try {
        const vSnap = await getDocs(query(collection(db, 'vouchers'), where('userId', '==', userId)));
        setVouchers(vSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch {
        setVouchers([]);
      }
      try {
        const mSnap = await getDocs(query(collection(db, 'movimientos'), where('clienteId', '==', userId)));
        setMovimientos(mSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch {
        setMovimientos([]);
      }
      setLoading(false);
    };
    load();
  }, [userId]);

  const history = withRunningBalance(movimientos, userPoints);
  const sortedVouchers = [...vouchers].sort((a, b) => {
    const rank = (v) => (getVoucherStatus(v) === 'ACTIVO' ? 0 : 1);
    if (rank(a) !== rank(b)) return rank(a) - rank(b);
    return 0;
  });

  return (
    <div className="px-4 py-6 pb-10 max-w-2xl mx-auto">

      <h1 className="text-2xl font-black mb-1">Mis puntos</h1>
      <p className="text-sm text-gray-500 mb-5">Tus vouchers y el historial de movimientos.</p>

      <div className="flex gap-2 mb-5">
        {[
          { id: 'vouchers', label: 'Vouchers' },
          { id: 'historial', label: 'Historial' },
        ].map((item) => (
          <button
            key={item.id}
            onClick={() => setTab(item.id)}
            className={`h-10 px-4 rounded-full text-sm font-black ${
              tab === item.id ? 'bg-maja-red text-white' : 'bg-gray-100 text-gray-700'
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-gray-400 font-extrabold py-8">Cargando...</p>
      ) : tab === 'vouchers' ? (
        sortedVouchers.length === 0 ? (
          <p className="text-sm text-gray-500">Todavía no generaste vouchers.</p>
        ) : (
          <div className="space-y-3">
            {sortedVouchers.map((v) => (
              <VoucherCard key={v.id} voucher={v} />
            ))}
          </div>
        )
      ) : history.length === 0 ? (
        <p className="text-sm text-gray-500">Todavía no hay movimientos.</p>
      ) : (
        <div className="divide-y divide-gray-100">
          {history.map((mov) => (
            <MovementRow key={mov.id} mov={mov} />
          ))}
        </div>
      )}

      {setCurrentView && (
        <button
          onClick={() => setCurrentView('home')}
          className="mt-8 h-11 w-full rounded-full bg-maja-red text-white font-black"
        >
          Volver al Club
        </button>
      )}
    </div>
  );
};

export default ClubHistory;
